// Lazy load function
const lazyLoad = (file) => () =>
    import(/* webpackChunkName: "[request]" */ `@/views/finance/journals/${file}.vue`);

export default [
    // Journal
    {
        path: "/journals",
        name: "journals-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Journals",
        },
        components: {
            content: lazyLoad("journal-list"),
        },
    },
    // {
    //     path: "/journals/create",
    //     name: "journals-create",
    //     meta: {
    //         requiresAuth: true,
    //         applicationFeatureCode: "Journals",
    //     },
    //     components: {
    //         content: lazyLoad('journal'),
    //     },
    // },
    {
        path: "/journals/create*",
        name: "journals-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Journals",
        },
        components: {
            content: lazyLoad("journal-v2"),
        },
    },
    // {
    //     path: "/journals/review/:id",
    //     name: "journals-review",
    //     meta: {
    //         requiresAuth: true,
    //         applicationFeatureCode: "Journals",
    //     },
    //     components: {
    //         content: lazyLoad('journal'),
    //     },
    // },
    {
        path: "/journals/review/:id",
        name: "journals-review-v2",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Journals",
        },
        components: {
            content: lazyLoad("journal-v2"),
        },
    },
];